module.exports = __webpack_public_path__ + "img/where-cover-photo-is.87e4fd54.png";